import React from 'react'
import {
  BasicDropdown,
  SearchInput
} from '../../../components'

// const optionsDate = [{
//   label: 'Past 30 Days',
//   value: 0
// }]

const Sidebar = ({setFiltered}) => {
  return (
    <div className="lg:pr-12" /* onClick={() => setFiltered(true)} */>
      <div className="mb-8">
        <p className="font-bold text-sm mb-4">Search by Keyword</p>
        <SearchInput disabled={true}/>
      </div>
      <div className="mb-8">
        <p className="font-bold text-sm mb-4">Category</p>
        <BasicDropdown
          placeholder="Category"
          options={[]}
        />
      </div>
      {/* <div className="mb-8">
        <p className="font-bold text-sm mb-4">Location</p>
        <BasicDropdown
          placeholder="Province"
          options={[]}
        />
        <BasicDropdown
          placeholder="City"
          options={[]}
          disabled={true}
        />
      </div>
      <div className="mb-8">
        <p className="font-bold text-sm mb-4">Type</p>
        <BasicDropdown
          placeholder="Organization"
          options={[]}
        />
        <BasicDropdown
          placeholder="Approach"
          options={[]}
        />
        <BasicDropdown
          placeholder="Issue"
          options={[]}
        />
      </div>
      <div>
        <p className="font-bold text-sm mb-4">Date</p>
        <BasicDropdown
          placeholder="Date"
          options={optionsDate}
          defaultValue={optionsDate[0]}
        />
      </div> */}
    </div>
  )
}

export { Sidebar }